import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { FileName } from '@gem/ui-kit';

import { FileState as SharedFileIcon } from 'APP/main/components/FileState/FileState';
import { FilePayload } from 'STORE/Messages/Message/Payload/FilePayload/FilePayload';

import { useFileItemPresenter } from './FileItem.presenter';
import styles from './FileItem.styles.m.css';

interface IFileItem {
  id: string;
  messageId: string;
  groupId: string;
  payload: FilePayload;
  serverTime: string;
}

export const FileItem: FC<IFileItem> = observer((props) => {
  const { id: payloadId, groupId, payload, serverTime, messageId } = props;

  const { fileName } = payload;
  const presenter = useFileItemPresenter({
    serverTime,
    payload,
    payloadId,
    groupId,
    messageId,
  });

  return (
    <div className={styles.container}>
      <SharedFileIcon
        groupId={groupId}
        messageId={messageId}
        payloadId={payloadId}
        onClick={presenter.onDownload}
      />
      <div className={styles.info}>
        <FileName
          className={styles.title}
          name={fileName}
        />
        <p className={styles.description}>{presenter.formattedBytes}</p>
      </div>
    </div>
  );
});
